import { Container } from "react-bootstrap";

export const SoftwareService = () => {
  return (
    <div>
    <header className="header">
      <h1>SOFTWARE SERVICES</h1>
    </header>
    <Container>
        {/* <!-- left --> */}
        <div>
            <h4>
                Nated Systems IoT Services has the expertise to help you build IoT capabilities that can increase operational efficiency and increase Revenue  
            </h4>
        </div>

        {/* <!-- right --> */}
        <div>
          <p>
             We hosts applications for customers and make the application available to them via the internet.
              Our business applications, including email and collaboration, customer relationship management (CRM), billing/payroll processing, enterprise resourcing planning (ERP), content management, and document editing and management.
              We hosts applications for customers and make the application available to them
              via the internet. Our business applications, including email and collaboration,
              customer relationship management (CRM), billing/payroll processing, enterprise
              resourcing planning (ERP), content management, and document editing and
              management. The SaaS model can reduce costs for IT infrastructure. It can also
              minimize some of the time spent on management tasks, because a SaaS
              provider is responsible for upgrades and management.
          </p>
          <p>
              The SaaS model can reduce costs for IT infrastructure. It can also minimize some of the time spent on management tasks, because a SaaS provider is responsible for upgrades and management.  
          </p>

          <h5>How can we help you</h5>
          <ul>
              <li>Stay up to date with the latest releases and unlimited upgrades </li>
              <li>Reduce capital expenditures and eliminate up-front costs </li>
              <li>Free up internal resources and let our administrators do the work </li>
              <li>Quickly scale and only pay for what you need, when you need it </li>
              <li>Secure, scalable, reliable and always available IT </li>
              <li>Require zero infrastructure to get up and running.  </li>
              <li>Integrates with other web-based applications.  </li>
              <li>Guaranteed 99.9% availability </li>
          </ul>
        </div>
    </Container>
    </div>
  );
}

export const PlatformService = () => {
  return (
    <div>
    <header className="header">
      <h1>PLATFORM SERVICES</h1>
    </header>
    <Container>
      <div>
          {/* <!-- left --> */}
          <div>
              <h4>
                  Nated Systems provide a platform for building software delivered over the web.  
              </h4>
          </div>

          {/* <!-- right --> */}
          <div>
                  <p>
                      Our platform offer a very good way to develop a scalable web application. 
                      PaaS provides a platform on which software can be developed and deployed. 
                      The platform handles the complexity around operating systems and servers and leaves application developers free to concentrate on the business requirements of the software. 
                        
                  </p>
                  <p>
                      We provides services like middleware, development tools, business intelligence services, and other development infrastructure  
                  </p>

                  <h3>How can we help you</h3>
                  <ul>
                      <li>Ease-of-building user interfaces</li>
                      <li>Scalability</li>
                      <li>Platform management overhead</li>
                      <li>Workflow engine capability</li>
                      <li>Services-enabled integration</li>
                      <li>Development environment creation</li>
                      <li>Upgrades and platform fixes</li>
                      
                  </ul>

          </div>
      </div>
    </Container>
    </div>
  );
}

export const InfrastructureService = () => {
  return (
    <div>
    <header className="header">
      <h1>INFRASTRUCTURE SERVICES</h1>
    </header>
    <Container>
      <div>
        {/* <!-- left --> */}
        <div>
            <h4>
                Nated Systems delivery model for cloud services where customers purchase access to managed IT infrastructure over the internet.  
            </h4>
        </div>

        {/* <!-- right --> */}
        <div>
          <p>
              We provide a platform on which software can be developed and deployed.
              The provision of basic cloud infrastructures like virtualized servers, storage, and
              networking in an on-demand model, which can easily scale up and down to
              meet demand. 
              
          </p>
          <p>
              Our platform handles the complexity around operating systems
              and servers and leaves application developers free to concentrate on the
              business requirements of the software.
          </p>

          <h3>How can we help you</h3>
          <ul>
              <li>Uptime percentage offered in SLA </li>
              <li>Ease of scaling up or down in response to consumer needs </li>
              <li>Administration automation for deploying and managing virtual desktops and servers </li>
              <li>Preconfigured templates for virtual machines </li>
              <li>Monitoring tools providing alerts when problems are detected </li>
              <li>Compliance with security protocols </li>
              <li>Highest availability and security </li>
              <li>Multi-data centre </li>
              <li>Managed Hosting </li>
              <li>Back-up services </li>
              <li>Disaster recovery </li>
          </ul>
        </div>
      </div>
    </Container>
    </div>
  );
}

